import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { ClipBox } from '../../connect-3d-ext/clip-box/clip-box.models';
import { injectLogger } from '../../logging/logger-injection';
import { GET_SCAN_PROJECT_URL } from '../../utils/get-scan-project-url';
import {
  PointcloudExport,
  PointcloudExportRequest,
} from './pointcloud-export.models';

export interface ClipAndSaveRequest {
  name: string;
  pointcloudIds: string[];
  clipBox?: ClipBox;
  geoJsonFilter?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ClipAndSaveService {
  private readonly http = inject(HttpClient);
  private readonly getScanProjectUrl$ = inject(GET_SCAN_PROJECT_URL);
  private readonly logger = injectLogger('ClipAndSaveService');

  submit(request: ClipAndSaveRequest): Observable<PointcloudExport> {
    const body: PointcloudExportRequest = {
      name: request.name,
      pointcloudIds: request.pointcloudIds,
      format: 'laz',
      clipBoxFilter: request.clipBox,
      geoJsonFilter: request.geoJsonFilter,
    };

    return this.getScanProjectUrl$('/exports').pipe(
      switchMap((url) => this.http.post<PointcloudExport>(url, body)),
      catchError((err) => {
        this.logger.error('Clip-and-save submit failed', {}, err);
        return throwError(() => err);
      }),
    );
  }
}
